import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

interface Props {
  focused: boolean;
}

const SelectViewButton = styled.button<Props>`
  background: ${(props) => (props.focused ? 'white' : 'none')};
  border: ${3 * Screen.widthRatio}px solid white;
  border-radius: ${50 * Screen.widthRatio}px;
  color: ${(props) => (props.focused ? 'black' : 'white')};
  font-family: ${Fonts['regular']};
  font-size: ${42 * Screen.widthRatio}px;
  line-height: ${48 * Screen.widthRatio}px;
  padding: ${15 * Screen.widthRatio}px 0;
  width: ${375 * Screen.widthRatio}px;
  position: relative;
  top: ${120 * Screen.widthRatio}px;

  &:hover {
    background: white;
    color: black;
  }
`;

export default SelectViewButton;
